import moment from 'moment';
import { head } from 'lodash';

class UpgradeEventController {

    constructor(upgradeService, basket, messageService) {
        this.upgradeService = upgradeService;
        this.basket = basket;
        this.messageService = messageService;
    }

    originalPrice () {
        let price = this.upgrade.availability.original_price - this.event.item_summary.price.original_price;
        if (this.events) {
            price = price * this.events.length;
        }
        return price;
    }

    upgradePrice () {
        if (this.event.item.type_name === 'OptionGroupOption') {
            return this.upgrade.availability.price - this.event.item_summary.price.original_price;
        }

        let price = this.upgrade.availability.price - this.event.item_summary.price.price;
        if (this.events) {
            price = price * this.events.length;
        }
        return price;
    }

    eventTypeDisplayName () {
        let eventType = this.event.item.type_name;

        switch (eventType) {
            case 'SpaDay':
                return 'Spa Day';
            case 'OptionGroupOption':
                return 'Treatment';
            default:
                return eventType;
        }
    }

    upgradeEvent () {
        if (this.events || this.event) {
            if (!this.events) {
                this.events = [this.event];
            }
            return this.upgradeService.upgrade(this.events)
                .then(() => {
                    this.getSuggestions();
                })
                .catch(() => {
                    let string = `one or more events could not be upgraded`;
                    if (this.events.length === 1) {
                        string = `we could not upgrade ${head(this.events).item.override_name || head(this.events).item_summary.name}`;
                    }
                    this.messageService.failure(`Sorry, ${string}. Please try again or contact us for help.`);
                    this.messageService.push();
                });
        }
    }

    eventOriginalName () {
        if (this.event.item_summary.type_name === 'OptionGroupOption') {
            return this.event.item.override_name || this.event.item.name;
        }

        return this.event.upgrade_from_name;
    }

    eventUpgradedName () {
        if (this.event.item_summary.type_name === 'OptionGroupOption') {
            return this.event.item.upgrade_name || this.event.item_summary.name;
        }

        return this.event.item.name;
    }

    displayDate () {
        let date = moment(this.event.date).format('dddd, Do MMMM, YYYY');
        if (this.event.preferred_time) {
            date = `${date} at ${this.event.preferred_time.substring(0, 5)}`;
        }
        return date;
    }
}

UpgradeEventController.$inject = ['upgradeService', 'basket', 'messageService'];

export default UpgradeEventController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/checkout/controllers/upgrade.event.controller.js